module.exports = __webpack_public_path__ + "img/notifications2.f7558a18.svg";